import './Footer.css'

export default function Footer() {
	return (
		<footer>
			<div className="container">
			<p className="credit">Made by <a href="https://twitter.com/Siddharth_Roy12" target="_blank" rel="noreferrer">Siddharth Roy</a></p>
			<p className="built-using">Built using <a href="https://reactjs.org/" target="_blank" rel="noreferrer">React</a></p>
			<p className="inspiration">Inspired by <a href="https://ezprompt.net/" target="_blank" rel="noreferrer">ezprompt.net</a></p>
			</div>
		</footer>
	)
}